import React from 'react';
import { connect } from 'react-redux';
import './LanguageSelector.scss';
import LanguageMenu from './LanguageMenu';
import { toggleLanguageMenu } from '../../redux/actions';
import generateFlag from './generateFlag';

const LanguageSelector = props => {
    if (props.configuration && props.configuration.languages) {
        return (
            <div id="languageselector">
                <div id="languagebutton" className={`flag ${props.currentLanguage.code}`} onClick={() => props.toggleLanguageMenu(!props.isLanguageMenuOpen)}>{generateFlag(props.currentLanguage.code)}</div>
                <LanguageMenu />
            </div>
        );
    } else {
        return null;
    }
};

const mapStateToProps = state => {
    return {...state};
};

export default connect(mapStateToProps, {toggleLanguageMenu})(LanguageSelector);